import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled from 'styled-components';
import { connect } from '../../Store';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: ${rem(46)};
  border: ${rem(1)} solid #cbd2d7;
  text-align: center;
  margin-top: ${rem(10)};
  margin-bottom: ${rem(10)};
`;

const Step = styled.div`
  width: ${props => (props.width ? `${props.width}%` : 'unset')};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-left: solid #cbd2d7 ${props => (props.isFirst ? rem(0) : rem(1))};
  background: ${props => (props.selected ? '#cbd2d7' : 'none')};
`;

class InfoBox extends React.Component {
  render() {
    const { steps, selected, onStepClick } = this.props;

    return (
      <Wrapper>
        {steps.map((step, index) => {
          return (
            <Step
              onClick={() => onStepClick(step.id)}
              selected={step.id === selected}
              isFirst={index === 0}
              width={100 / steps.length}
            >{`${index + 1}. ${step.title}`}</Step>
          );
        })}
      </Wrapper>
    );
  }
}

InfoBox.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      id: PropTypes.number,
    }),
  ).isRequired,
  selected: PropTypes.number,
  onStepClick: PropTypes.func,
};

InfoBox.defaultProps = {
  selected: 1,
  onStepClick: () => {},
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(InfoBox);



// WEBPACK FOOTER //
// ./src/Components/Stepper/index.jsx